import { useIsBrandPreview } from "@faire/retailer-visitor-shared/lib/getIsBrandPreview";
import { getBrand } from "@faire/retailer-visitor-shared/serialized-data/getBrand";
import { specialHolidayNet90Active } from "@faire/retailer-visitor-shared/settings/getSettingSpecialHolidayNet90";
import { useMarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { getLoggedOutPromoBanners } from "@faire/retailer-visitor-shared/stores/ui/getLoggedOutPromoBanners";
import { getLocationOrThrow } from "@faire/web--source/common/globals/getLocation";
import React from "react";
export var useLoggedOutPromoBanners = function() {
    var location = getLocationOrThrow();
    var isBrandPreview = useIsBrandPreview();
    var brand = getBrand();
    var _useMarketStore = useMarketStore([
        "isPreshowOrLive"
    ]), isFaireMarketPreshowOrLive = _useMarketStore.isPreshowOrLive;
    var isSpecialHolidayNet90Active = specialHolidayNet90Active();
    var promoBanners = React.useMemo(function() {
        return getLoggedOutPromoBanners({
            location: location,
            isBrandPreviewAndBrandIsInactive: isBrandPreview && !(brand === null || brand === void 0 ? void 0 : brand.first_active_at),
            isFaireMarketPreshowOrLive: isFaireMarketPreshowOrLive,
            isSpecialHolidayNet90Active: isSpecialHolidayNet90Active
        });
    }, [
        location,
        isBrandPreview,
        brand,
        isFaireMarketPreshowOrLive,
        isSpecialHolidayNet90Active
    ]);
    return promoBanners;
};
